import moment from "moment";

/**
 * Type for date input values
 */
export type DateInput = string | Date | number;

/**
 * Utility function to format dates consistently across the application
 * This replaces react-moment usage with direct moment formatting
 */
export const formatDate = (date: DateInput, format: string = "DD-MM-YYYY"): string => {
    if (!date) {
        return "";
    }
    return moment(date).format(format);
};

/**
 * Common date formats used throughout the application
 */
export const DateFormats = {
    DATE_ONLY: "DD-MM-YYYY",
    DATE_TIME: "DD-MM-YYYY HH:mm",
    DATE_TIME_SECONDS: "DD-MM-YYYY HH:mm:ss",
    ISO_DATE: "YYYY-MM-DD",
    MONTH_YEAR: "MM-YYYY",
    FULL_DATE: "dddd, MMMM Do YYYY",
} as const;

/**
 * Format date with default format (DD-MM-YYYY)
 */
export const formatDateDefault = (date: DateInput): string =>
    formatDate(date, DateFormats.DATE_ONLY);

/**
 * Format date with time
 */
export const formatDateTime = (date: DateInput): string =>
    formatDate(date, DateFormats.DATE_TIME);
